import { ContractBC } from "../model/ContractBCModel";
import { KeydrivePlan } from "../model/UserModel";

export const getInitialContract = (): ContractBC => ({
        idContractCockpit: "******************",
        nameCustumer: "******************",
        respCustumer: "******************",
        emailResp: "******************",
        phone: "******************",
        contractNumber: "******************",
        contractValidity: new Date(),
        price: 0,
        totalUsers: 0,
        usersUsed: 0,
        status: 0,
        loginType: 0,
        limitStorage: 0,
        farmServerName: "******************",
        organizations: [],
        symbol: "**",
        idContract: "******************",
        currenci: 0,
        plan: KeydrivePlan.ESSENCIAL
    });

export const storageTotalSizeContracted = "*** GB";